import {extendUrl3D, extendUrlFactory} from '../views/helpers/extenent-url'
import {stripAuthParams} from './urlParams'

/**
 * Đường dẫn sang trang đăng nhập của app 3D, kèm chỗ cần quay lại sau khi đăng nhập xong.
 *
 * Hợp đồng do 3D quy định (`3d-webapp/src/app/login/components/LoginPage.js` — commit `69cf76cf`
 * trên `master`, `96ee41ed` trên `release`; hai bản nội dung trùng khít):
 *
 *     referrer = encodeURIComponent(`${origin}${pathname}${search}`)
 *
 * Bên đó đọc bằng `new URLSearchParams(search).get('referrer')` — hàm này TỰ percent-decode, nên
 * query của chính ta sống sót thay vì lẫn vào query của trang login.
 *
 * ⚠️ `encodeURIComponent` là bắt buộc, không phải cho đẹp. Gửi thô kèm query thì `URLSearchParams`
 *    cắt ở dấu `&` ĐẦU TIÊN: `?from=…&to=…&actors=…` chỉ còn `from`, hai tham số sau rơi vào query
 *    của trang login rồi mất. Hỏng im lặng — link vẫn mở được, chỉ là ra bộ số khác.
 *
 * ⚠️ Hàm này phải là NƠI DUY NHẤT dựng URL đăng nhập. Trước đây mỗi lối vào tự nối chuỗi một kiểu,
 *    nên đường này giữ được bộ lọc còn đường kia mất sạch — cùng một tính năng mà hai lối vào cho
 *    hai kết quả.
 *
 *    Trên `release` còn một lối thứ hai là interceptor 401 của `services/api/createAxiosClient.js`.
 *    Nhánh `master` KHÔNG có file đó (`createApiServices` dựng `Axios.create()` trực tiếp, việc xử
 *    lý 401 nằm ở `EnsureLoggedIn`), nên ở đây chỉ còn các lối trong `EnsureLoggedIn`.
 *
 *    ⚠️ Đừng đọc câu trên thành "401 giữa phiên được `EnsureLoggedIn` xử lý giúp". Subscriber 401
 *       của nó là code CHẾT với lỗi thân JSON: interceptor của `createApiServices` trải phẳng lỗi
 *       nên mất `.response`, còn `_makeAuthRequest` thoát sớm ở `if (!response)` trước khi bắn
 *       subscriber. Service này luôn trả thân JSON ⇒ 401 giữa phiên KHÔNG tự đăng xuất. Tình trạng
 *       có sẵn trên `master`, không phải do nhóm màn này gây ra.
 *
 * Gửi kèm `search` để share-link giữ nguyên bộ lọc: nhóm màn Định mức & Sản lượng đặt toàn bộ bộ lọc
 * lên URL (xem `views/helpers/useUrlFilters.js`) và người dùng được khuyến khích copy URL gửi cho
 * nhau. Thiếu `search` thì người nhận đăng nhập xong đáp xuống màn hình với bộ lọc mặc định "hôm
 * nay", đọc một bộ số khác hẳn mà không có dấu hiệu gì báo link đã bị cắt.
 *
 * Origin phải nằm trong whitelist của 3D (`helpers/isAllowedReferrerOrigin.js`): `localhost`,
 * `192.168.x.x`, và `*.merchize.com`. Vì vậy vẫn lấy `extendUrlFactory.url` (tức
 * `REACT_APP_URL_FACTORY`) chứ KHÔNG lấy `window.location.origin` — chạy dev ở một host khác là rớt
 * whitelist, 3D đẩy về trang chủ của nó.
 */
export const loginUrl = ({pathname, search} = {}) => `${extendUrl3D.url}/login?referrer=`
    + encodeURIComponent(extendUrlFactory.url + (pathname || '/') + stripAuthParams(search))

export default loginUrl
